import React from "react";
import ReactDOM from "react-dom";
import ProgressBar from "./utils/ProgressBar";

class Timer extends React.Component {
    constructor() {
      super();
      this.state = { time: {}, seconds: 40 };
      this.timer = 0;
      this.startTimer = this.startTimer.bind(this);
      this.countDown = this.countDown.bind(this);
    }
  
    secondsToTime(secs){
      let hours = Math.floor(secs / (60 * 60));
  
      let divisor_for_minutes = secs % (60 * 60);
      let minutes = Math.floor(divisor_for_minutes / 60);
  
      let divisor_for_seconds = divisor_for_minutes % 60;
      let seconds = Math.ceil(divisor_for_seconds);
  
      let obj = {
        "h": hours,
        "m": minutes,
        "s": seconds
      };
      return obj;
    }
  
    
    componentDidMount() {
      
      let timeLeftVar = this.secondsToTime(this.props.seconds );
      this.setState({seconds:this.props.seconds })
      this.setState({ time: timeLeftVar });
      this.startTimer()
      
    }
  
    startTimer() {
      if (this.timer == 0 && this.state.seconds > 0) {
        this.timer = setInterval(this.countDown, 1000);
      }
    }
  
    countDown() {
      // Remove one second, set state so a re-render happens.
      let seconds = this.state.seconds - 1;
      this.setState({
        time: this.secondsToTime(seconds),
        seconds: seconds,
      });
      
      // Check if we're at zero.
      if (seconds == 0) { 
        clearInterval(this.timer);
        this.props.parentCallback(true);
      }
    }
  
    render() {
      return(
        <div>    

           <div width= "200px">
         
        <ProgressBar key="" bgcolor="#ef6c00" completed={Math.round((this.state.seconds * 100)/this.props.seconds)} timestring = {this.state.time.m + " : "+  this.state.time.s} />
        </div>

         
         
         
         

        </div>
      );
    }
  }
  
  //ReactDOM.render(<Timer/>, document.getElementById('View'));

export default Timer;